/**
 * Azure AD returns one access token per resource (audience).
 * Including Graph scopes (e.g. User.Read) with api:// scopes often yields a Graph token —
 * backends expecting api://... must receive a token acquired with API-only scopes.
 */

function parseScopeArray(raw: string | undefined): string[] {
  if (!raw?.trim()) return [];
  try {
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed)
      ? parsed.filter((s): s is string => typeof s === "string" && s.length > 0)
      : [];
  } catch {
    return [];
  }
}

/** Scopes whose access token targets your KB API (used for login consent and acquireTokenSilent). Set `REACT_APP_API_SCOPES` to a JSON array, e.g. `["api://CLIENT_ID/scope_name"]`. */
export function getKbApiScopes(): string[] {
  return parseScopeArray(process.env.REACT_APP_API_SCOPES);
}

/**
 * Login / consent scopes: OIDC baseline plus your API scope(s). Do not add Graph scopes
 * (User.Read etc.) unless you separately acquire a Graph token — they invalidate API tokens.
 */
export function getMsalLoginScopes(): string[] {
  const loginOnly = parseScopeArray(process.env.REACT_APP_LOGIN_SCOPES);
  if (loginOnly.length > 0) return loginOnly;

  const api = getKbApiScopes();
  const base = ["openid", "profile"];
  return Array.from(new Set(base.concat(api)));
}
